import(/* webpackMode: "eager" */ "/home/foneorders.com/app/src/app/(landing)/pricing/page.tsx");
